<template>
	<div>
		<header class="page-title">
			<h2 @click="loadProviderList">Edit Provider Sharings</h2>
			<div class="ml-auto">
				<a @click="saveProviderListSharing" class="btn btn-md btn-success"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>
		<div class="form-group mb-0">
			<label for="affiliate-tag">Affiliate Tag</label>
			<input id="affiliate-tag" name="affiliate-tag" type="text" v-model="affiliateTag">
		</div>
		<hr>
		<div>
			<header class="section-title mt-2">
				<h3>Partnership</h3>
				<div class="ml-auto">
					<a @click="showPartnerModal(true)" class="btn btn-md btn-success"><i class="fas fa-plus"></i> Add New Partner</a>
				</div>
			</header>
			<div class="table-responsive">
				<table>
					<thead>
						<tr>
							<th>Name</th>
							<th>ID</th>
							<th>URL</th>
							<th>Language</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody v-if="typeof sharing === 'object'">
						<tr v-for="(partner,index) in orderedSharings">
							<td>{{ partner.name }}</td>
							<td>{{ partner.id }}</td>
							<td>{{ partner.url }}</td>
							<td>{{ partner.language }}</td>
							<td class="nowrap">
								<a @click="showPartnerModal(index)" class="btn btn-icon btn-primary" title="Edit"><i class="fas fa-fw fa-pencil-alt"></i></a>
								<a @click="deletePartner(index)" class="btn btn-icon btn-danger" title="Delete"><i class="fas fa-fw fa-trash"></i></a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<modal @close="closeModal" v-show="partnerModalVisible">
			<template slot="header">
				<h4 class="modal-title" v-if="newPartner">New Partner</h4>
				<h4 class="modal-title" v-if="!newPartner">Edit Partner</h4>
			</template>
			<template slot="body">
				<div class="flex box start">
					<div class="form-group six-lg">
						<label for="partner-name">Name</label>
						<input id="partner-name" name="partner-name" type="text" v-model="actualPartner.name">
					</div>
					<div class="form-group six-lg">
						<label for="partner-id">URL</label>
						<input :disabled="!newPartner" @keyup.enter="checkUrlSharing" id="partner-url" name="partner-url" type="url" v-model="actualPartner.url">
					</div>
					<div class="form-group three-lg">
						<label for="partner-language">Language</label>
						<select id="partner-language" v-model="actualPartner.language" @change="checkUrlSharing">
							<option :value=null>Select a language</option>
							<option v-for="language in availableLanguages" :value="language.locale">{{ language.title }}</option>
						</select>
					</div>
					<div class="form-group three-lg">
						<label for="partner-id">Generated ID</label>
						<input @keyup="checkUrlSharing" disabled id="partner-id" name="partner-url" type="url" v-model="actualPartner.id">
					</div>
					<div class="form-group six-lg">
						<p>{{ modalMessage }}</p>
					</div>
					<div class="form-group twelve-lg">
						<label for="prologue">Prologue</label>
						<textarea class="textarea-small" id="prologue" name="prologue" v-model="actualPartner.prologue"></textarea>
					</div>
					<div class="form-group twelve-lg" v-if="Object.keys(actualPartner).length > 0">
						<label>Taglines</label>
						<table>
							<thead>
								<tr>
									<th>Provider</th>
									<th>Tagline</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(provider,index) in providerList.providers">
									<td>{{ index + 1 }}. {{ provider.name }}</td>
									<td>
										<input type="text" v-model="actualPartner.taglines[provider.id]">
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="form-group twelve-lg">
						<label for="iframe">Iframe</label>
						<textarea disabled class="textarea-small disabled" id="iframe" name="iframe" rows="2"><iframe src="{{$selectedSite.actualUrl + '/api/providerlist/list/' + actualPartner.id}}" style="border:0px #ffffff hidden;" name="proPrivacy" scrolling="no" frameborder="1" marginheight="0px" marginwidth="0px" height="400px" width="600px" allowfullscreen></iframe></textarea>
					</div>
					<div class="form-group twelve-lg">
						<label for="json">Json</label>
						<input id="json" type="text" disabled :value="$selectedSite.actualUrl + '/api/providerlist/json/' + actualPartner.id">
					</div>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeModal" class="btn btn-md btn-primary modal-close"><i class="fas fa-times"></i> Cancel</a>
				<a :disabled="!urlCheck" @click="addPartner" class="btn btn-md btn-success" v-if="newPartner"><i class="fas fa-plus"></i> Add Partner</a>
				<a @click="saveProviderListSharing" class="btn btn-md btn-success" v-if="!newPartner"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>
	</div>
</template>

<script>
import modal from '../Modal/DefaultModal.vue';
import Errors from "../../Utils/Errors";

export default {
	components: {
		"modal": modal,
	},
	props: {},
	data() {
		return {
			providerList: {},
			userRoles: this.$currentUserRoles,
			languages: this.$availableLanguages,
			selectedLanguage: 0,
			selectedLanguageSlug: '',
			availableLanguages: this.$availableLanguages,

			affiliateTag: '',
			sharing: {},

			partnerModalVisible: false,
			actualPartner: {},
			newPartner: false,
			urlCheck: false,
			modalMessage: '',

			errors: new Errors(),
		}
	},
	created() {
		this.loadProviderList();
	},
	computed: {
		orderedSharings: function () {
			return _.orderBy(this.sharing.partners, ['name'], ['asc'])
		},
	},
	methods: {
		showPartnerModal: function (index) {
			this.newPartner = false;
			if (index === true) {
				this.newPartner = true;
				this.resetActualPartner();
			} else {
				this.actualPartner = this.sharing.partners[index];
			}

			if (typeof this.actualPartner.taglines !== 'object') {
				this.actualPartner.taglines = {};
			}

			let vm = this;
			Object.keys(this.providerList.providers).forEach(key => {
				let provider = vm.providerList.providers[key];
				if (typeof vm.actualPartner.taglines[provider.id] === 'undefined') {
					vm.actualPartner.taglines[provider.id] = '';
				}
			});

			this.urlCheck = false;
			this.partnerModalVisible = true;
		},
		closeModal: function () {
			this.resetActualPartner();
			this.partnerModalVisible = false;
		},
		resetActualPartner: function () {
			this.actualPartner = {
				name: '',
				id: '',
				url: '',
				prologue: '',
				taglines: {},
				language: null,
			};
			this.modalMessage = '';
			if (this.newPartner) {
				this.modalMessage = 'Press enter in the URL field to generate the ID';
			}
		},
		loadProviderList: function () {
			let vm = this;

			axios.post('/api/' + vm.$selectedSite.slug + '/providerlists/getlist')
					.then(response => {
						vm.providerList = response.data.providerList;
						vm.sharing = response.data.sharing;
						vm.affiliateTag = '';
						if (typeof vm.sharing === 'object' && vm.sharing.hasOwnProperty('affiliate_tag')) {
							vm.affiliateTag = response.data.sharing.affiliate_tag;
						}
						this.setLanguage(0);
					});
		},
		setLanguage: function (index) {
			let vm = this;
			this.selectedLanguage = index;
			this.selectedLanguageSlug = this.languages[index].locale;
		},
		saveProviderListSharing: function () {
			let vm = this;

			axios.post('/api/' + vm.$selectedSite.slug + '/providerlists/savesharing', {
				affiliate_tag: vm.affiliateTag,
				partners: vm.sharing.partners,
			})
					.then(response => {
						vm.closeModal();
						vm.loadProviderList();
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('Provider List saving failed.', 'Error');
					});
		},
		checkUrlSharing: function () {
			this.urlCheck = false;

			if (this.actualPartner.url.replace(' ', '') === '') {
				return true;
			}
			this.actualPartner.id = '';

			this.modalMessage = 'Checking URL...';
			let vm = this;
			axios.post('/api/' + vm.$selectedSite.slug + '/providerlists/checkurl', {
				url: vm.actualPartner.url,
				language: vm.actualPartner.language
			})
					.then(response => {
						vm.urlCheck = response.data.check;
						if (response.data.check === false) {
							vm.$toastr.error('This url is already saved', 'Error');
							vm.modalMessage = 'This url is already saved, enter a new one or change the language';
						}
						if (response.data.check === true) {
							vm.actualPartner.id = response.data.id;
							vm.modalMessage = '';
						}
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('URL check failed.', 'Error');
					});
		},
		addPartner: function () {
			if (!this.urlCheck) {
				return true;
			}
			if (typeof this.sharing !== 'object') {
				this.sharing = {};
			}
			if (!this.sharing.hasOwnProperty('partners')) {
				this.sharing.partners = [];
			}
			if (!Array.isArray(this.sharing.partners)) {
				this.sharing.partners = [];
			}

			this.sharing.partners.push(this.actualPartner);
			this.closeModal();
			this.saveProviderListSharing();
		},
		deletePartner: function (index) {
			this.$delete(this.sharing.partners, index);
			this.saveProviderListSharing();
		}
	}
}
</script>

